import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Background } from './components/Background';
import { Changes } from './components/Changes';
import { Offer } from './components/Offer';
import { WhyUs } from './components/WhyUs';
import { PremiumPartners } from './components/PremiumPartners';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans bg-gray-50 text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Background data-id="element-3" />
      <Changes data-id="element-4" />
      <Offer data-id="element-5" />
      <WhyUs data-id="element-6" />
      <PremiumPartners data-id="element-7" />
      <Contact data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}